import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  static targets = ["input"];
  static values = {
    lazy: Boolean,
    overwrite: Boolean,
    minAge: Number,
  };

  connect() {
    IMask(this.inputTarget, this.maskOptions);
  }

  get maxDate() {
    if (this.hasMinAgeValue && this.minAgeValue > 0) {
      const max = new Date();
      max.setFullYear(max.getFullYear() - this.minAgeValue);
      return max;
    }
    return new Date();
  }

  get maskOptions() {
    return {
      mask: Date,
      pattern: "d/`m/`Y",
      blocks: {
        d: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31,
          maxLength: 2,
        },
        m: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
          maxLength: 2,
        },
        Y: {
          mask: IMask.MaskedRange,
          from: 1900,
          to: new Date().getFullYear() + 1,
          maxLength: 4,
        },
      },
      format: function (date) {
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        if (day < 10) day = "0" + day;
        if (month < 10) month = "0" + month;

        return [day, month, year].join("/");
      },
      parse: function (str) {
        var yearMonthDay = str.split("/");
        return new Date(yearMonthDay[2], yearMonthDay[1] - 1, yearMonthDay[0]);
      },
      min: new Date(1900, 0, 1),
      max: this.maxDate,
      autofix: true,
      // The default allows the native placeholder to show until user types
      lazy: this.hasLazyValue ? this.lazyValue : true,
      overwrite: this.hasOverwriteValue ? this.overwriteValue : false,
    };
  }
}
